<!--Modal Custom Wrapper-->
<div class="ces-modal-popup-wrapper">
  <!--Modal Header-->
  <div class="k-window-titlebar k-dialog-titlebar set-alert-modal-header">
    <div class="k-window-title k-dialog-title">
      <span>{{ title }}</span>
    </div>
    <div class="k-window-actions k-dialog-actions">
      <ces-button
        size="small"
        icon="icon-close"
        [ghost]="true"
        [onlyIcon]="true"
        [ghostType]="'secondary'"
        btnClass="ces-icons set-alert-modal-header-close"
        iconPosition="left"
        (onClick)="onCancel()"
      ></ces-button>
    </div>
  </div>

  <!--Modal Content-->
  <div
    class="k-content k-window-content k-dialog-content set-alert-modal-content k-window-content-height k-window-auth-mfa-modal-content"
  >
    <div class="ces-form-component">
      <ng-container *ngIf="verifyPassword">
        <div class="pwd-container">
          <div class="row">
            <div class="col-md-12">
              <p class="verify-pwd-msg">
                To continue setting up your authentication method, first, verify your password.
              </p>
            </div>
            <div class="col-md-8">
              <div class="pwd-input-submit">
                <div class="ces-form-group required">
                  <label class="ces-label ces-label-2 ces-text-medium"
                    >Password
                    <span class="required-field">*</span>
                  </label>
                  <ces-textbox
                    inputType="password"
                    placeholder="Enter new password"
                    [(ngModel)]="password"
                    iconPosition="left"
                    id="reset_new"
                    icon="icon-password"
                    size="medium"
                  >
                  </ces-textbox>
                </div>
              </div>
            </div>
            <div class="col-md-4 verify-pwd-btn">
              <div class="pwd-confirm-btn">
                <ces-button
                  label="Confirm"
                  status="primary"
                  (onClick)="confirmPwd()"
                  [disabled]="!password || loader"
                  [loading]="loader"
                  loaderPosition="left"
                ></ces-button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="
          !verifyPassword &&
          (authenticatorMode == 'otp' || authenticatorMode == 'push-notification')
        "
      >
        <div class="qr-code-container">
          <div class="row mb-3">
            <div class="col-12">
              <div class="step-label">STEP ONE</div>
            </div>
            <div class="col-12">
              <span class="step-desc">
                {{
                  authenticatorMode == 'otp'
                    ? 'Download/Use any authenticator application (Google Authenticator, Microsoft Authenticator etc)'
                    : 'In order to continue, install the Auth0 Guardian app via the app store'
                }}
                on your mobile device.
              </span>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <div class="step-label">STEP TWO</div>
            </div>
            <div class="col-12">
              <span class="step-desc">
                On your authenticator application, tap the "+" icon and then select "Scan QR code"
                to scan the QR code below
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="qr-code-block">
                <qrcode
                  [qrdata]="barcodeUri"
                  [width]="220"
                  [errorCorrectionLevel]="'M'"
                  [imageHeight]="75"
                  [imageWidth]="75"
                ></qrcode>
              </div>
            </div>
          </div>
          <div
            class="row mb-3"
            *ngIf="authenticatorMode == 'otp'"
          >
            <div class="col-12">
              <div class="step-label">STEP THREE</div>
            </div>
            <div class="col-12 mb-3">
              <span class="step-desc">
                Once this code has been scanned, enter the 6-digit code generated by the app.
              </span>
            </div>
            <div class="col-12 text-align-center">
              <ng-otp-input
                (onInputChange)="onOtpChange($event)"
                [config]="{ length: 6, allowNumbersOnly: true }"
              ></ng-otp-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12 align-self-end qr-code-submit-btn">
              <ces-button
                *ngIf="authenticatorMode == 'push-notification'"
                label="Confirm"
                status="primary"
                (onClick)="submitQrCode()"
                [loading]="loader"
                loaderPosition="left"
              ></ces-button>
              <ces-button
                *ngIf="authenticatorMode == 'otp'"
                label="Confirm"
                status="primary"
                (onClick)="submitQrCode()"
                [disabled]="!qrOtp || loader"
                [loading]="loader"
                loaderPosition="left"
              ></ces-button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!verifyPassword && authenticatorMode == 'sms'">
        <div class="qr-code-container">
          <div
            class="row"
            *ngIf="smsStep1"
          >
            <div class="col-12">
              <div class="step-label">STEP ONE</div>
            </div>
            <div class="col-12">
              <span class="step-desc">
                Receive a code via SMS to authenticate. Enter your phone number below.
              </span>
            </div>
            <div class="col-md-12 mt-3 mb-3">
              <div class="ces-form-group required">
                <label class="ces-label ces-label-2 ces-text-medium">Contact Number</label>
                <ces-tel-input
                  [phoneValidation]="true"
                  [preferredCountries]="preferredCountries"
                  [(ngModel)]="phoneNumber"
                  [searchCountryFlag]="true"
                  [searchCountryFieldValues]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                  name="phoneNumber"
                  [phoneNumberFormat]="PhoneNumberFormat.National"
                  [selectedCountryISO]="selectedCountryISO"
                  [error]="loadingConfig?.errorObj?.contact_number?.isError"
                  [errorMessage]="loadingConfig.errorObj.contact_number?.error"
                  (onErrorEvent)="onContactNumberError($event)"
                ></ces-tel-input>
                <div
                  *ngIf="phoneError"
                  class="input-helper invalid-input-message"
                >
                  {{ phoneErrorMsg }}
                </div>
              </div>
            </div>
            <div class="col-md-12 text-align-right">
              <ces-button
                label="Submit"
                status="primary"
                [disabled]="!phoneNumber || loader || phoneError"
                (onClick)="submitPhoneNumber()"
                [loading]="loader"
                loaderPosition="left"
              ></ces-button>
            </div>
          </div>
          <div
            class="row mb-3"
            *ngIf="smsStep2"
          >
            <div class="col-12">
              <div class="step-label">STEP TWO</div>
            </div>
            <div class="col-12">
              <span class="step-desc"> Enter the code sent to your phone number. </span>
            </div>
            <div class="col-md-12 text-align-center mb-3 mt-3">
              <ng-otp-input
                (onInputChange)="onSMSOtpChange($event)"
                [config]="{ length: 6, allowNumbersOnly: true }"
              ></ng-otp-input>
            </div>
            <div class="col-md-12 text-align-right">
              <ces-button
                label="Submit"
                status="primary"
                [disabled]="!userSMSOtp || loader"
                (onClick)="submitSMSOtp()"
                [loading]="loader"
                loaderPosition="left"
              ></ces-button>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="qr-code-block">
                <qrcode
                  [qrdata]="barcodeUri"
                  [width]="220"
                  [errorCorrectionLevel]="'M'"
                  [imageHeight]="75"
                  [imageWidth]="75"
                ></qrcode>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!verifyPassword && authenticatorMode == 'email'">
        <div class="qr-code-container">
          <div
            class="row"
            *ngIf="emailStep1"
          >
            <div class="col-12">
              <div class="step-label">STEP ONE</div>
            </div>
            <div class="col-12">
              <span class="step-desc">
                Receive a code via Email to authenticate. Enter your Email address below.
              </span>
            </div>
            <div class="col-md-12 mt-3">
              <div class="ces-form-group required">
                <label class="ces-label ces-label-2 ces-text-medium"
                  >Email Address
                  <span class="required-field">*</span>
                </label>
                <ces-textbox
                  inputType="email"
                  placeholder="Enter new email"
                  [(ngModel)]="userEmail"
                  id="emailid"
                  size="medium"
                >
                </ces-textbox>
              </div>
            </div>
            <div class="col-md-12 text-align-right">
              <ces-button
                label="Submit"
                status="primary"
                [disabled]="!userEmail || loader"
                (onClick)="submitEmailEnroll()"
                [loading]="loader"
                loaderPosition="left"
              ></ces-button>
            </div>
          </div>
          <div
            class="row mb-3"
            *ngIf="emailStep2"
          >
            <div class="col-12">
              <div class="step-label">STEP TWO</div>
            </div>
            <div class="col-12 text-align-center mb-2">
              <span class="step-desc"> Enter the code sent to your email address. </span>
            </div>
            <div class="col-md-12 mg-3 mb-3 text-align-center">
              <ng-otp-input
                (onInputChange)="onEmailOtpChange($event)"
                [config]="{ length: 6, allowNumbersOnly: true }"
              ></ng-otp-input>
            </div>
            <div class="col-md-12 text-align-right">
              <ces-button
                label="Submit"
                status="primary"
                [disabled]="!userEmailOtp || loader"
                (onClick)="submitEmailOtp()"
                [loading]="loader"
                loaderPosition="left"
              ></ces-button>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="qr-code-block">
                <qrcode
                  [qrdata]="barcodeUri"
                  [width]="256"
                  [errorCorrectionLevel]="'M'"
                  [imageHeight]="75"
                  [imageWidth]="75"
                ></qrcode>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
